import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Grid,
  Divider,
  IconButton
} from '@material-ui/core';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import ContactPhoneIcon from '@material-ui/icons/ContactPhone';
import GetAppIcon from '@material-ui/icons/GetApp';

const useStyles = makeStyles(theme => ({
  root: {},
  imageContainer: {
    height: 64,
    width: 64,
    margin: '0 auto',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '5px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  image: {
    width: '100%'
  },
  statsItem: {
    display: 'flex',
    alignItems: 'center'
  },
  statsIcon: {
    color: theme.palette.icon,
    marginRight: theme.spacing(1)
  }
}));

const InterviewCard = props => {
  const { className, interview, ...rest } = props;

  const classes = useStyles();

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent>
        <Typography
          align="center"
          gutterBottom
          variant="h4"
        >
          {interview.company}
        </Typography>
        <Typography
          align="center"
          variant="body1"
        >
          {interview.format}
        </Typography>
        <Typography
          align="center"
          variant="body1"
        >
          {interview.interviewer}
        </Typography>
      </CardContent>
      <Divider />
      <CardActions>
        <Grid
          container
          justifyContent="space-between"
        >
          <Grid
            className={classes.statsItem}
            item
          >
            <AccessTimeIcon className={classes.statsIcon} />
            <Typography
              display="inline"
              variant="body2"
            >
              Fecha {interview.createdAt}
            </Typography>
          </Grid>
          <Grid
            className={classes.statsItem}
            item
          >
            <IconButton
              color="inherit"
              onClick={() => {}}
            >
              <ContactPhoneIcon  />
            </IconButton>
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
};

InterviewCard.propTypes = {
  className: PropTypes.string,
  interview: PropTypes.object.isRequired
};

export default InterviewCard;
